import { GlobalState, UI } from '@leverege/ui-redux';
import { GroupDelegate } from '@leverege/molten/imagine';
import PositionPendingButton from './PositionPendingButton';
const handles = context => {
  const {
    streetView
  } = context;
  const mapEditing = UI.get(GlobalState.get(), 'mapEditing');
  if (context.clientProps.item) {
    // only show on group screens, not item screns
    return false;
  }
  if (!(context.clientProps.actions instanceof GroupDelegate)) {
    return false;
  }
  return mapEditing !== true && !streetView;
};
export default {
  id: 'map.positionPendingButton',
  name: 'Positions Pending',
  matches: [{
    use: 'bottomLeftActionBar',
    client: ['MapDataViewer'],
    objectType: ['vehicle', 'locator']
  }, {
    use: 'topLeftActionBar',
    client: ['GoogleMapsDataViewer'],
    objectType: ['vehicle', 'locator']
  }],
  handles,
  customComponent: PositionPendingButton
};